import * as Popover from "@radix-ui/react-popover";
import { ReactElement, useState } from "react";

/**
 * A student's credit balance (the People panel's Owes chip, the Billing
 * tab's Credit Balance) opens a small menu: View credit balance or Charge
 * for credits. The owner keeps the windows, so they stay open while the
 * balance changes under them.
 */
export default function CreditMenu({
  children,
  onView,
  onCharge,
}: {
  /** The balance itself, as a button. */
  children: ReactElement;
  onView: () => void;
  onCharge: () => void;
}) {
  const [open, setOpen] = useState(false);
  const choose = (action: () => void) => () => {
    setOpen(false);
    action();
  };

  return (
    <Popover.Root open={open} onOpenChange={setOpen}>
      <Popover.Trigger asChild>{children}</Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          className="people-panel__menu people-panel__menu--over-dialogs"
          align="start"
          sideOffset={4}
        >
          <button
            type="button"
            className="people-panel__menu-item"
            onClick={choose(onView)}
          >
            View credit balance
          </button>
          <button
            type="button"
            className="people-panel__menu-item"
            onClick={choose(onCharge)}
          >
            Charge for credits
          </button>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
